module.exports = __webpack_public_path__ + "img/icdeposit.2c888b23.png";